// ================= Home Part ==================== //
export const SAVE_LOADINGS = 'SAVE_LOADINGS';
export const LOAD_NEWS = 'LOAD_NEWS';
export const LOAD_BLOG = 'LOAD_BLOG';
export const LOAD_SERVICES = 'LOAD_SERVICES';
export const LOAD_NEW_CATEGORY = 'LOAD_NEW_CATEGORY';
export const LOAD_BLOG_CATEGORY = 'LOAD_BLOG_CATEGORY';
export const LOAD_LIST_JOB = 'LOAD_LIST_JOB';
export const LOAD_JD = 'LOAD_JD';